// extracted by mini-css-extract-plugin
export default {"arrowRight":"szUCb"};